"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleNameSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
exports.impossibleNameSchema = zod_1.z.object({
    firstName: constants_1.defaultPersonNameString,
    middleName: zod_1.z.string().max(constants_1.MAX_PERSON_NAME_LENGTH),
    lastName: constants_1.defaultPersonNameString
}).strict();
